import styled from 'styled-components'

import { ChipInput, ChipLabel, ChipWrapper } from '../FilterChip/styled'

export const Wrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme['-ds-space-01']};

  ${ChipWrapper} {
    flex: 1 1 0;
    min-width: 0;
  }

  /* Equal-width segments centre their label, so the chip's hug-content
     padding would only clip it at narrow widths */
  ${ChipLabel} {
    padding: 0;
    border-radius: ${({ theme }) => theme['-ds-radius-md']};
  }

  /* Unselected segments keep the md radius; only the row's outer corners
     are fully rounded, and the selected segment becomes a pill */
  ${ChipWrapper}:first-child ${ChipLabel} {
    border-top-left-radius: ${({ theme }) => theme['-ds-radius-round']};
    border-bottom-left-radius: ${({ theme }) => theme['-ds-radius-round']};
  }

  ${ChipWrapper}:last-child ${ChipLabel} {
    border-top-right-radius: ${({ theme }) => theme['-ds-radius-round']};
    border-bottom-right-radius: ${({ theme }) => theme['-ds-radius-round']};
  }

  ${ChipInput}:checked + ${ChipLabel} {
    border-radius: ${({ theme }) => theme['-ds-radius-round']};
  }
`
